import { useCallback } from 'react';
import axiosInstance from '../../../axiosInstance';

const useAssessmentReviewApi = () => {
  const getAssessmentTab = useCallback(
    (requestId) =>
      axiosInstance.get(`/api/v1/assessment-review/tab/${requestId}`),
    []
  );

  const submitAssessmentReview = useCallback(
    (assignmentId, assessment_status, rejection_reason) =>
      axiosInstance.post(`/api/v1/assessment-review/${assignmentId}/submit`, {
        assessment_status,
        ...(rejection_reason ? { rejection_reason } : {}),
      }),
    []
  );

  const getComments = useCallback(
    (assignmentId) =>
      axiosInstance.get(`/api/v1/assessment-review/comments/${assignmentId}`),
    []
  );

  const addComment = useCallback(
    (assignmentId, comment, attachedFiles) =>
      axiosInstance.post(`/api/v1/assessment-review/comments/${assignmentId}`, {
        comment,
        attachedFiles,
      }),
    []
  );

  const updateComment = useCallback(
    ({ id, comment, attachedFilesToAdd, attachedFilesToRemove }) =>
      axiosInstance.put(`/api/v1/assessment-review/comments/${id}`, {
        comment,
        attachedFilesToAdd,
        attachedFilesToRemove,
      }),
    []
  );

  const deleteComment = useCallback(
    ({ id }) =>
      axiosInstance.delete(`/api/v1/assessment-review/comments/${id}`),
    []
  );

  return {
    getAssessmentTab,
    submitAssessmentReview,
    getComments,
    addComment,
    updateComment,
    deleteComment,
  };
};

export default useAssessmentReviewApi;
